<template>
  <div>
    <ul class="list">
      <li class="item" v-for="(v, k) in dataList" :key="k">
        <div v-if="v.insuranceStatus==='examine_pass'&&(v.payStatus==='payYet'||v.payStatus==='partRefund')" class="item-status">待生效</div>
        <div v-else class="item-status">{{ v.insuranceStatus  | policyStatus }}</div>
        <div class="item-name">巴陵e惠保</div>
        <table>
          <tr>
            <td class="left-td">保单号：</td>
            <td>{{ v.insuranceNo }}</td>
          </tr>
          <tr>
            <td class="left-td">购买人：</td>
            <td>{{ v.appntName }}</td>
          </tr>
          <tr>
            <td class="left-td">被保人：</td>
            <td>{{ v.userName  }}</td>
          </tr>
          <!-- <tr>
            <td class="left-td">投保时间：</td>
            <td>{{ v.polApplyDate | shortDate }}</td>
          </tr> -->
          <tr>
            <td class="left-td">保险期间：</td>
            <td>{{ v.startDate | shortDate }}零时至{{ v.endDate | shortDate }}二十四时</td>
          </tr>
          <!-- <tr>
            <td class="left-td">支付状态：</td>
            <td>{{ v.payStatus | payStatus }}</td>
          </tr> -->
          <tr>
            <td class="left-td">保单状态：</td>
            <td v-if="v.insuranceStatus=='examine_pass' || v.insuranceStatus=='effective'">已生效</td>
            <td v-if="v.insuranceStatus=='preEffective' && v.payStatus=='payYet'">待生效</td>
            <td v-if="v.insuranceStatus=='generating' && v.payStatus=='payYet'">生成中</td>
            <td v-if="v.insuranceStatus=='unEffective'||v.insuranceStatus=='theEnd'">已终止</td>
          </tr>
          <!-- <tr>
            <td class="left-td">保费：</td>
            <td>￥{{ v.insuredFeeAmount }}</td>
          </tr> -->
        </table>
        <div class="tr-flex" v-if="v.insuranceStatus === 'effective' || v.insuranceStatus === 'partEffective' || v.insuranceStatus === 'generating'" @click="makeVoucher(v)">个人电子凭证</div>
      </li>
    </ul>
  </div>
</template>

<script>
import { PolicyPayStatus, PolicyStatus, DeductionMethod } from '@/util/enum-data'
import { getPaymentUrl, findPolicyUrl } from '@/api/user'

export default {
  name: 'PolicyList',
  props: {
    dataList: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  data() {
    return {
    }
  },
  filters: {
    payStatus: function (val) {
      return PolicyPayStatus[val] || ''
    },
    policyStatus(val) {
      return PolicyStatus[val] || ''
    },
    shortDate: function (val) {
      return val ? val.substr(0, 10) : ''
    },
    insuredFilter(val) {
      const arr = val.userInsureEntities.reduce((a, b) => {
        const name = b.personnelType === 'insured' ? [b.userName] : []

        return [].concat(a, name)
      }, [])
      return arr.join(', ')
    }
  },
  methods: {
    // 电子凭证
    async makeVoucher(v) {
      if (v.insuranceStatus === 'generating') {
        this.$dialog.alert({
          message: '凭证生成中，请稍后查询',
          theme: 'round-button',
          messageAlign: 'center'
          }).then(() => {
             // on close
           })
      } else {
        this.$toast.loading({
          message: '加载中...',
          forbidClick: true,
        });
        try {
          let res = await findPolicyUrl({
            insuranceId: v.userInsureId,
            userInsurePersonId: v.userInsurePersonId
          })
          if (res) {
            this.$toast.clear();
            window.location.href = res
          }
        } catch (e) {
          this.$toast.clear();
          this.$notify({ type: 'danger', message: e.message })
        } 
      }
    },
    // 取支付
    async goPay(item) {
      const res = await getPaymentUrl({
        orderSn: item.selfPolicySn,
        openId: this.$store.state.userInfo.openId,
        payType: "weichatAcc",
        clientPayType: "JSAPI"
      })
      window.location.href = res.paymentUrl
    },
    handlePayStatus(status) {
      return DeductionMethod[status] || ''
    },
  }
}
</script>

<style scoped lang="scss">
.list {
  padding: 10px 0;
}
.item {
  position: relative;
  width: 100%;
  padding: 10px;
  margin-bottom: 10px;
  border-radius: 5px;
  color: #4c4c4c;
  background-color: #fff;
  box-shadow: 0px 0px 5px 0px rgba(106, 0, 0, 0.14);
  border-radius: 16px;
  .item-status {
    position: absolute;
    top: 18px;
    right: 0;
    padding: 0 10px;
    border-top-left-radius: 10px;
    border-bottom-left-radius: 10px;
    font-size: 15px;
    line-height: 1.5;
    text-align: center;
    color: #fff;
    background-color: #fc8c34;
  }

  .item-name {
    width: 75%;
    margin-bottom: 5px;
    font-size: 16px;
    height: 40px;
    display: flex;
    align-items: center;
  }

  .item-info {
    margin-bottom: 3px;
    font-size: 15px;
    line-height: 1.5;
  }
  table {
    width: 100%;
    padding-bottom: 5px;
    border-top: 1px dashed #ccc;
    border-bottom: 1px dashed #ccc;
    padding: 10px 0;
    margin-bottom: 20px;
    tr {
      & > .left-td {
        width: 24% !important;
      }
    }

    td {
      font-size: 14px;
      line-height: 20px;
    }
  }
  .btn-two {
    display: flex;
    justify-content: space-around;
    align-items: center;
    .btn-div {
      flex: 1;
      margin: 0 10px;
      display: flex;
      justify-content: center;
      align-items: center;
      height: 30px;
      border-radius: 15px;
      color: #fff;
      text-align: center;
      font-size: 16px;
      background: linear-gradient(to right, #db0003 0%, #ff6c61 100%);
    }
  }
  .tr-flex {
    width: 179px;
    margin: 10px auto;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #f4111f;
    // background: linear-gradient(to right, #db0003, #ff6c61);
    background-color: #fff;
    border: 1px solid #f4111f;
    background-size: contain;
    background-position-x: center;
    border-radius: 16px;
    height: 33px;
    font-size: 15px;
    font-weight: 500;
  }
  .go-gift-friends {
    width: 80%;
    margin-left: auto;
    margin-right: auto;
    text-align: center;
    background: linear-gradient(to right, #f8c847 0%, #e88e53 100%);
    color: #fff;
    font-size: 15px;
    line-height: 15px;
    border-radius: 15px;
  }
  .onerenewal_flex {
    margin-top: 10px;
  }
}
</style>
